import React from "react"
import OfferCommonDataForm from "../../../../common/commonData/OfferCommonDataForm";

const CONTRACTOR_ADDITIONAL_OFFER_EDIT_COMMON_DATA_FORM_ID = "cont_additional_offer_edit_common_data";

function AdditionalOfferCommonData(
    {
        offerEdit,
        section
    }) {

    return <OfferCommonDataForm
        offerEdit={offerEdit}
        section={section}
        onSubmit={() => void 0}
        formId={CONTRACTOR_ADDITIONAL_OFFER_EDIT_COMMON_DATA_FORM_ID}
        working={false}
        disabled
    />
}

AdditionalOfferCommonData.propTypes = {}
export default AdditionalOfferCommonData;